import Cookies from 'js-cookie';

export function isEditMode() {
  return document.body.getAttribute('data-editmode') === 'true';
}

export function redirectToUserLanguage() {
  if (isEditMode() || Cookies.get('languageSwitch')) {
    return;
  }

  const allowedLanguages = ['de', 'en'];
  let userLanguage = navigator.language || navigator.browserLanguage;
  userLanguage = userLanguage.substring(0,2);
  let currentLang = document.querySelector("meta[property='og:locale']").getAttribute('content');
  currentLang = currentLang.substring(0,2);

  if (userLanguage === currentLang) {
    return;
  }

  if (allowedLanguages.includes(userLanguage)) {
    return window.location.replace(window.location.origin + '/' + userLanguage);
  }

  if (currentLang !== 'en') {
    return window.location.replace(window.location.origin + '/en');
  }

}
